import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { applySettings } from "@/lib/layout";

const SettingsContext = createContext(null);

export { SettingsContext };


export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      applySettings(data);
    } catch {
      /* fall back to code defaults */
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <SettingsContext.Provider value={{ settings, setSettings, reloadSettings: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || {};
